import { palette } from './tokens';

export const cssVars: Record<string, string> = {
  '--anl-accent': palette.indigo,
  '--anl-bg': palette.bg,
  '--anl-surface': palette.surface,
  '--anl-surface-elev': palette.surfaceElev,
  '--anl-border': palette.border,
  '--anl-metric-bg': palette.border,
  '--anl-text': palette.text,
  '--anl-text-muted': palette.textMuted,
  '--anl-success': '#10b981',
  '--anl-warning': palette.yellow,
  '--anl-error': palette.red,
};
